// src/components/Notification.js
import React, { useEffect } from 'react';
import './Notification.css'; // This will point to the new, empty CSS for now

function Notification({ message, type, onClose }) {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000); 
      return () => clearTimeout(timer);
    }
  }, [message, onClose]);

  if (!message) {
    return null;
  }

  return (
    <div className={`notification notification-${type}`}>
      <span className="notification-message">{message}</span>
      <button onClick={onClose} className="notification-close-btn" aria-label="Close notification">
        &times;
      </button>
    </div>
  );
}

export default Notification;